// Module
var code = "<template> <div class=\"comp-notify ${type.toLowerCase()}\"> <comp-icon class=\"comp-notify--icon\" icon=\"${icon}\" if.bind=\"icon\"></comp-icon> <p class=\"comp-notify--description\"> <slot></slot> </p> </div> </template>";
// Exports
module.exports = code;